import { InspectionAttachment } from '@centecomm/portal-service';
import { DocumentLink } from 'Types';

export const mapInspectionAttachmentToDocumentLink = ({ name, url }: InspectionAttachment): DocumentLink => {
    const identifier = encodeURIComponent(name);

    return {
        title: name,
        link: url,
        identifier,
    };
};
